import { z } from 'zod';
// ProductPin schema
export const ProductPinSchema = z.object({
    productId: z.string(),
    position: z.union([
        z.number(),
        z.object({
            start: z.number(),
            end: z.number()
        })
    ])
});
// ProductBoost schema
export const ProductBoostSchema = z.object({
    productId: z.string(),
    score: z.number()
});
// MerchandisingRule schema
export const MerchandisingRuleSchema = z.object({
    id: z.string(),
    name: z.string(),
    conditions: z.array(z.object({
        field: z.string(),
        operator: z.string(),
        value: z.any()
    })),
    actions: z.array(z.object({
        type: z.string(),
        params: z.any()
    }))
});
// ABTest schema
export const ABTestSchema = z.object({
    experimentId: z.string().optional(),
    variantId: z.string().optional(),
    testId: z.string().optional(),
    variant: z.number().optional(),
    trafficPercentage: z.number().optional()
});
// Main MerchandisingConfig schema
export const MerchandisingConfigSchema = z.object({
    // Common features across platforms
    pins: z.array(ProductPinSchema).optional(),
    boosts: z.array(ProductBoostSchema).optional(),
    hideProducts: z.array(z.string()).optional(),
    // Algolia specific
    ruleContexts: z.array(z.string()).optional(),
    enableRules: z.boolean().optional(),
    enablePersonalization: z.boolean().optional(),
    userToken: z.string().optional(),
    // Unbxd specific
    pageType: z.string().optional(),
    categoryId: z.string().optional(),
    // Boost specific
    boostProducts: z.array(z.string()).optional(), // Alternative to boosts
    pinProducts: z.array(z.object({
        productId: z.string(),
        position: z.number()
    })).optional(), // Alternative to pins
    applyRules: z.boolean().optional(),
    // Shopify specific
    collectionId: z.string().optional(),
    useManualSort: z.boolean().optional(),
    featuredOnly: z.boolean().optional(),
    // Advanced features
    customRules: z.array(MerchandisingRuleSchema).optional(),
    abTest: z.object({
        experimentId: z.string().optional(),
        variantId: z.string().optional(),
        testId: z.string().optional(),
        variant: z.number().optional(),
        trafficPercentage: z.number().optional()
    }).optional(),
    // User profile for personalization
    userProfile: z.object({
        userToken: z.string().optional(),
        segments: z.array(z.string()).optional()
    }).optional(),
    // Feature toggles
    enabled: z.boolean().optional(),
    // Optional merchandising-specific filters
    merchandisingFilters: z.string().optional(),
    // Catch-all for platform-specific options
    platformOptions: z.record(z.any()).optional()
});
